function addAnimationObserver() {
  const elements = document.querySelectorAll('.animate');

  const observer = new IntersectionObserver(
    entries => {
      for (const entry of entries) {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add('animate--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    {
      rootMargin:
        window.innerWidth < 600 ? '0px 0px 0px 0px' : '60px 0px 0px 0px',
    }
  );

  for (const element of elements) {
    observer.observe(element);
  }
}

setTimeout(() => {
  addAnimationObserver();
}, 500);
